(function() {
  // -----------------------------------------------
  // FREE GIFT CONFIGURATION
  var FREE_GIFT_VARIANT_ID = 59901776200014;
  var MINIMUM_SPEND = 3000; // £30.00 in pence
  // -----------------------------------------------

  // --- PART 1: Add free gift if ?gift=true is in the URL ---
  var params = new URLSearchParams(window.location.search);

  if (params.get('gift') === 'true') {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var alreadyInCart = cart.items.some(function(item) {
          return item.variant_id === FREE_GIFT_VARIANT_ID;
        });

        if (!alreadyInCart) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,
              properties: {
                '_gift': 'true',
                'Free Gift': '✓'
              }
            })
          })
          .then(function() {
            window.location.href = '/cart';
          })
          .catch(function(err) {
            console.error('Could not add free gift:', err);
          });
        } else {
          window.location.href = '/cart';
        }
      });
  }

  // --- PART 2: Lock quantity to 1 via API if changed ---
  function enforceGiftQuantity() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var giftItem = cart.items.find(function(item) {
          return item.variant_id === FREE_GIFT_VARIANT_ID;
        });

        if (giftItem && giftItem.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: FREE_GIFT_VARIANT_ID.toString(),
              quantity: 1
            })
          })
          .then(function() {
            window.location.reload();
          });
        }
      });
  }

  // --- PART 3: Hide quantity controls for gift item ---
  function hideGiftQuantityControls() {
    var giftInputs = document.querySelectorAll(
      'input[data-quantity-variant-id="' + FREE_GIFT_VARIANT_ID + '"]'
    );

    giftInputs.forEach(function(giftInput) {
      if (giftInput.dataset.giftLocked) return;
      giftInput.dataset.giftLocked = 'true';

      var colWrapper = giftInput.closest('.m-cart__column--quantity');
      if (colWrapper) colWrapper.style.display = 'none';

      var drawerWrapper = giftInput.closest('.m-cart-drawer-item__quantity');
      if (drawerWrapper) drawerWrapper.style.display = 'none';

      giftInput.setAttribute('readonly', 'true');
      giftInput.setAttribute('disabled', 'true');
      giftInput.value = '1';

      var quantityComponent = giftInput.closest('m-quantity-input');
      if (quantityComponent) {
        var buttons = quantityComponent.querySelectorAll('.m-quantity__button');
        buttons.forEach(function(btn) {
          btn.disabled = true;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.3';
        });
      }
    });
  }

  // --- PART 4: Check minimum spend and control all checkout buttons ---
  function enforceMinimumSpend() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {

        var giftInCart = cart.items.some(function(item) {
          return item.variant_id === FREE_GIFT_VARIANT_ID;
        });

        if (!giftInCart) return;

        var spendTotal = 0;
        cart.items.forEach(function(item) {
          if (item.variant_id !== FREE_GIFT_VARIANT_ID) {
            spendTotal += item.line_price;
          }
        });

        // All checkout buttons including accelerated
        var checkoutButtons = document.querySelectorAll(
          '.tpo-btn-checkout, [name="checkout"]'
        );

        // Accelerated checkout wrappers (Shop Pay, Google Pay etc.)
        var acceleratedButtons = document.querySelectorAll(
          '.additional-checkout-buttons, shopify-accelerated-checkout-cart'
        );

        // Remove existing warnings
        document.querySelectorAll('.gift-min-spend-warning').forEach(function(el) {
          el.remove();
        });

        if (spendTotal < MINIMUM_SPEND) {
          var remaining = ((MINIMUM_SPEND - spendTotal) / 100).toFixed(2);

          // Hide standard checkout button and show warning
          checkoutButtons.forEach(function(btn) {
            btn.style.display = 'none';

            var warning = document.createElement('p');
            warning.className = 'gift-min-spend-warning';
            warning.textContent = 'Add £' + remaining + ' more to checkout with your free gift.';
            warning.style.cssText = [
              'color:#c00',
              'font-size:0.85em',
              'text-align:center',
              'margin:8px 0',
              'padding:8px 12px',
              'background:#fff3f3',
              'border-radius:4px',
              'display:block'
            ].join(';');

            btn.parentNode.insertBefore(warning, btn);
          });

          // Hide accelerated checkout buttons entirely
          acceleratedButtons.forEach(function(el) {
            el.style.display = 'none';
          });

        } else {
          // Restore all buttons
          checkoutButtons.forEach(function(btn) {
            btn.style.display = '';
          });

          acceleratedButtons.forEach(function(el) {
            el.style.display = '';
          });
        }
      });
  }

  // --- PART 5: Hard intercept on standard checkout button clicks ---
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.tpo-btn-checkout, [name="checkout"]');
    if (!btn) return;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var giftInCart = cart.items.some(function(item) {
          return item.variant_id === FREE_GIFT_VARIANT_ID;
        });

        if (!giftInCart) return;

        var spendTotal = 0;
        cart.items.forEach(function(item) {
          if (item.variant_id !== FREE_GIFT_VARIANT_ID) {
            spendTotal += item.line_price;
          }
        });

        if (spendTotal < MINIMUM_SPEND) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert('Please add £' + ((MINIMUM_SPEND - spendTotal) / 100).toFixed(2) + ' more to checkout with your free gift.');
        }
      });
  }, true);

  // --- PART 6: Run all UI logic ---
  function runCartLogic() {
    hideGiftQuantityControls();
    enforceMinimumSpend();
  }

  // Run on cart page
  if (window.location.pathname === '/cart') {
    enforceGiftQuantity();
    setTimeout(runCartLogic, 800);
  }

  // --- PART 7: Watch for drawer and cart updates ---
  function observeDrawer() {
    var footer = document.getElementById('MinimogCartDrawerFooter');
    var drawerItems = document.querySelector('m-cart-drawer-items');

    var targets = [footer, drawerItems].filter(Boolean);

    if (targets.length === 0) {
      setTimeout(observeDrawer, 500);
      return;
    }

    var observer = new MutationObserver(function() {
      setTimeout(runCartLogic, 300);
    });

    targets.forEach(function(target) {
      observer.observe(target, { childList: true, subtree: true, attributes: true });
    });
  }

  observeDrawer();

  ['cart:updated', 'cart:refresh', 'minimog:cart:updated', 'on:cart:updated'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      setTimeout(runCartLogic, 400);
    });
  });

  var drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target && mutation.target.classList &&
          mutation.target.classList.contains('m-cart-drawer--active')) {
        setTimeout(runCartLogic, 400);
      }
    });
  });

  var cartDrawer = document.getElementById('MinimogCartDrawer');
  if (cartDrawer) {
    drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  } else {
    var bodyObserver = new MutationObserver(function() {
      var drawer = document.getElementById('MinimogCartDrawer');
      if (drawer) {
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

})();